module.exports = __webpack_public_path__ + "img/lalamove-sad-face.bc4f9916.png";